import {
  AccessUsersToolTip,
  CustomTooltip,
  DataSourcesToolTip,
  IBtnTooltip,
  SidebarTooltip,
} from "../../pages/ReportDetails/Components/ReportTabs/TabsContent/reportDataPiece/tooltip/Tooltip.styled";

export const RenderTooltip = (props, text: string) => {
  return <CustomTooltip {...props}>{text}</CustomTooltip>;
};

export const RenderSideBarTooltip = (props, text: string, textAlignment: string = "center") => {
  return <SidebarTooltip {...props} textAlignment={textAlignment}>{text}</SidebarTooltip>;
};

export const RenderDataSources = (
  props,
  ipNames: string[],
  ipLogos: { [x: string]: any },
) => {
  return (
    <DataSourcesToolTip {...props}>
      {ipNames.map((item, index) => {
        return (
          <div className="container">
            <div className="imgContainer">
              <img className="img" src={ipLogos[item]}></img>
            </div>
            <div>{item}</div>
          </div>
        );
      })}
    </DataSourcesToolTip>
  );
};

export const RenderAccessToolTip = (props, users: string[]) => {
  return (
    <AccessUsersToolTip {...props}>
      <div className='listTitle'>
        Teammates with Access
      </div>
      <>
        <ul className='listItem'>
          {users.map((item, index) => {
            return (
              <li>{item}</li>
            )
          })}
        </ul>
      </>

    </AccessUsersToolTip>
  )
}

export const RenderIBtnTooltip = (props, title: string, subTitle: React.ReactNode) => {
  return (
    <IBtnTooltip  {...props}>
      <div className="iBtnContainer">
        <div className="title">
          {title}
        </div>
        <div className="subTitle">
          {subTitle}
        </div>
      </div>

    </IBtnTooltip>
  )
}
